import React from 'react';
import { StyleSheet, View } from 'react-native';

import { OEText } from '../../atoms';

export type OopsErrorMessageProps = {
  message: string;
};

export const OopsErrorMessage = ({ message }: OopsErrorMessageProps) => {
  return (
    <View style={styles.container}>
      <View>
        <OEText style={styles.title}>Oops</OEText>
        <OEText style={styles.text}>{message}</OEText>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: 15,
    paddingHorizontal: 20,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    fontSize: 20,
    textAlign: 'center',
  },
  title: {
    fontSize: 30,
    marginBottom: 10,
    textAlign: 'center',
  },
});
